import React, { useEffect, useContext, useState } from 'react'
import { View, StyleSheet, ScrollView } from 'react-native'
import { Text, Layout, Spinner, Button } from '@ui-kitten/components'
import { countSalesByProducts } from './statHelpers'
import { UserContext } from '../../global/UserProvider'
import Divider from '../../components/Divider'
import { getSalesOnDateRange } from '../../global/Firebase/firebase'
import { format } from 'date-fns'

import { useTranslation } from 'react-i18next'
import { dateRangeWithTimezoneAndAutoclose, getLocalStoreDate } from '../../utils/timezoneFunctions'
import { currencyFormatterAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'


export default function TodayProductStats({ style, store }) {
  const { t } = useTranslation()
  const [context, setContext] = useContext(UserContext)
  const currencyFormatter = useAtomValue(currencyFormatterAtom)
  const [isLoading, setIsLoading] = useState(false)
  const [stats, setStats] = useState({
    salesByProducts: [], // {name, quantity, finalItemPrice, checkQuantity, ...product}
  })
  const [weeklyTrue, setWeeklyTrue] = useState(false)

  useEffect(() => {
    getSales(store)  
  }, [store])

  const getSales = async (store) => {
    setIsLoading(true)
    let localStoreNow = getLocalStoreDate(store)
    let localStoreRange = dateRangeWithTimezoneAndAutoclose({startDate: localStoreNow, endDate: localStoreNow}, [store])
    let sales = await getSalesOnDateRange(context.db, localStoreRange, true, store)
    let salesByProducts = countSalesByProducts(sales, store)
    setStats({...stats, salesByProducts})
    setIsLoading(false)
  }

  return (
    <View  style={style}>
      <Text category='label' style={styles.header}>
        {t('stats.productsToday')}
      </Text>
      { isLoading ? (
        <View style={{alignItems: 'center', marginTop: 10}}><Spinner size="large" /></View>
      ) : (
        <Layout style={styles.tableView}>
          <View style={styles.rowItem}>
            <Text category='s2' style={styles.rowItemName}>{t('product')}</Text>
            <Text category='s2' style={styles.rowItemCheckQuantity}>{t('stats.receipts')}</Text>
            <Text category='s2' style={styles.rowItemQuantity}>{t('stats.quantityShort')}</Text>
            <Text category='s2' style={styles.rowItemAmount}>{t('stats.amount')}</Text>
            <Text category='s2' style={styles.rowItemAmount}>{t('stats.marginShort')}</Text>
          </View>
          <Divider width='100%' marginTop={7} />
          {stats.salesByProducts.map((item, index) => (
            <View key={item.id}>
              <View style={styles.rowItem}>
                <Text category='label' style={styles.rowItemName}>{item.name}</Text>
                <Text style={styles.rowItemCheckQuantity}>{item.checkQuantity}</Text>
                <Text style={styles.rowItemQuantity}>{item.quantity?.toFixed(1)}</Text>
                <Text style={styles.rowItemAmount}>{currencyFormatter.format(item.finalItemPrice)}</Text>
                <Text style={styles.rowItemAmount}>{currencyFormatter.format(item.margin)}</Text>
              </View>
              <Divider />
            </View>
          ))}
        </Layout>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    marginTop: 10,
    marginBottom: 5
  },
  tableView: {
    padding: 10,
    marginBottom: 10,
    borderRadius: 10,
  },
  rowItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 2,
  }, 
  rowItemName: {
    flex: 9
  }, 
  rowItemQuantity: {
    flex: 3,
    textAlign: 'center',
  }, 
  rowItemCheckQuantity: {
    flex: 2,
    textAlign: 'center',
  }, 
  rowItemAmount: {
    flex: 4,
    textAlign: 'right',
  },
})